import script from "./StatisticsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./StatisticsView.vue?vue&type=script&lang=ts&setup=true"

import "./StatisticsView.vue?vue&type=style&index=0&id=1341abef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1341abef"]])

export default __exports__